import { render, staticRenderFns } from "./CartComponentWrapper.vue?vue&type=template&id=5385773e"
import script from "./CartComponentWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./CartComponentWrapper.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports